/**
 * shadcn/ui Skeleton — vendored + tokenized for CertAIn v2 (Phase 1 fan-out foundation).
 *
 * A pulsing placeholder block on the CertAIn `surface-subtle` tint. No raw color
 * — resolves inside `[data-theme="v2"]`. Guard-clean.
 *
 * Used by loading states across the fan-out screens (candidate lists, detail
 * tabs, tables, charts) so batches render an honest skeleton, not a blank frame.
 */
import * as React from "react";
import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={cn(
        "animate-pulse rounded-[calc(var(--radius,0.5rem)-2px)] bg-surface-subtle",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
